import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Megaphone, X } from "@phosphor-icons/react";

export function AnnouncementBanner() {
  const qc = useQueryClient();
  const { data: anns = [] } = useQuery({
    queryKey: ["announcements-active"],
    queryFn: async () => (await api.get("/announcements/active")).data,
  });

  const dismiss = useMutation({
    mutationFn: async (id) => api.post(`/announcements/${id}/dismiss`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["announcements-active"] }),
  });

  if (!anns.length) return null;

  return (
    <div className="space-y-2 mb-6" data-testid="announcement-banners">
      {anns.map((a) => (
        <div key={a.id} data-testid={`announcement-banner-${a.id}`}
          className="flex items-start gap-3 p-4 rounded-md bg-primary/10 border border-primary/30">
          <Megaphone className="h-5 w-5 text-primary shrink-0 mt-0.5" weight="fill" />
          <div className="min-w-0 flex-1">
            <p className="font-bold text-sm">{a.title}</p>
            <p className="text-sm text-muted-foreground whitespace-pre-wrap">{a.body}</p>
          </div>
          <button data-testid={`dismiss-announcement-${a.id}`} onClick={() => dismiss.mutate(a.id)}
            className="text-muted-foreground hover:text-foreground transition-colors duration-200 shrink-0">
            <X className="h-4 w-4" weight="bold" />
          </button>
        </div>
      ))}
    </div>
  );
}
